import { FC } from "react";
import { motion } from "framer-motion";

import "./AmountsGrid.css";

import { Amount } from "../utils/context";
import { GridButton } from "./GridButton";
import { PrimaryLink } from "./PrimaryLink";
import { RouteKey } from "../configs/routes";
import { AmountIcons, Amounts } from "../configs/amounts";
import { useStorage } from "../utils/useStorage";
import { useCache } from "../utils/useCache";
import { CloseIcon } from "./Icons";

interface AmountsGridProps {
  onAdd: (amount: Amount) => void;
}

export const AmountsGrid: FC<AmountsGridProps> = ({ onAdd }) => {
  const { configMeasure } = useStorage();
  const { nextStepAnimationSkip } = useCache();

  const handleClick = (amount: Amount) => () => {
    onAdd(amount);
  }

  const hidden = {
    opacity: 0
  }

  const visible = {
    opacity: 1
  }

  return (
    <div className="amounts-grid">
      <div className="amounts-grid__buttons">
        {Amounts[configMeasure].map((amount, index) => (
          <div className="amounts-grid__item" key={amount.toString()}>
            <GridButton onClick={handleClick(amount)}>
              <svg viewBox="0 0 64 64" className="icon">
                <path d={AmountIcons[index]} />
              </svg>
              <motion.span
                style={nextStepAnimationSkip ? visible : hidden}
                animate={visible}
                transition={{
                  duration: 0.5
                }}
                className="post"
              >
                {amount} {configMeasure.toLowerCase()}
              </motion.span>
            </GridButton>
          </div>
        ))}
      </div>
      <PrimaryLink
        route={RouteKey.INDEX}
        className="amounts-grid__close"
      >
        <CloseIcon />
      </PrimaryLink>
    </div>
  )
}